// extracted by css-extract-rspack-plugin
export default {"Box":"PendingInvitationBanner-module__Box__pYtP3","Box_1":"PendingInvitationBanner-module__Box_1__PUhrX","Link":"PendingInvitationBanner-module__Link__G8u_a"};